import type { FC, ReactNode } from 'react'

import { Container } from '@/components/generals/container'
import { SectionHeading } from '@/components/generals/section-heading'
import { STEPS } from '@/constants/content'

export const ProcessSection: FC = (): ReactNode => {
    return (
        <section id='how-it-works' aria-labelledby='how-it-works-title' className='scroll-mt-20 bg-background py-20 sm:py-28'>
            <Container>
                <SectionHeading
                    id='how-it-works-title'
                    eyebrow='How it works'
                    title='From grimy to gleaming'
                    description='The same careful routine for every car, whichever package you choose.'
                    align='center'
                />

                <ol className='mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4'>
                    {STEPS.map((step, index) => (
                        <li key={step.title} className='relative overflow-hidden rounded-[1.75rem] border border-border bg-card p-7'>
                            <span
                                aria-hidden='true'
                                className='absolute -right-2 -top-4 font-heading text-[7rem] font-bold leading-none text-transparent [-webkit-text-stroke:1.5px_var(--color-aqua)]'
                            >
                                {String(index + 1).padStart(2, '0')}
                            </span>

                            <span className='relative grid size-12 place-items-center rounded-2xl bg-ink text-aqua'>
                                <step.icon className='size-6' />
                            </span>

                            <p className='relative mt-6 text-xs font-bold uppercase tracking-[0.2em] text-aqua-deep'>
                                Step {index + 1}
                            </p>

                            <h3 className='relative mt-1.5 font-heading text-2xl font-bold uppercase tracking-wide text-ink'>
                                {step.title}
                            </h3>

                            <p className='relative mt-2 leading-relaxed text-muted-foreground'>
                                {step.body}
                            </p>
                        </li>
                    ))}
                </ol>
            </Container>
        </section>
    )
}
